import Vue from "vue";
import VueResource from "vue-resource";
import { HttpResponse } from "vue-resource/types/vue_resource";

import { IAuthLogin } from "@/models/object";

Vue.use(VueResource);

export const authApi = {
  login,
  logout,
};

/**
 * WS de login
 *
 * @param {object} obj : le couple login / password
 * @return {Promise}
 */

function login(obj: IAuthLogin): PromiseLike<HttpResponse> {
  return Vue.http.post(`${process.env.VUE_APP_API_VEOS_URL}/login`, obj);
}

/**
 * WS de déconnexion
 *
 * @param {object} obj : le couple login / password
 * @return {Promise}
 */

function logout(obj: object): PromiseLike<HttpResponse> {
  return Vue.http.post(`${process.env.VUE_APP_API_VEOS_URL}/users/authenticate/logout`, obj);
}
